import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ReligionIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 19.667 21.203",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.203),
    children: [/*#__PURE__*/jsx("path", {
      d: "m3.167 20.5-1.79-2.237a4 4 0 0 1 -.876-2.5v-4.6a1.333 1.333 0 0 1 1.333-1.333 1.333 1.333 0 0 1 1.333 1.333v3.333"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.167 20.5v-2.787a3.994 3.994 0 0 0 -.673-2.222l-1.016-1.524a1.244 1.244 0 0 0 -1.757-.4 1.244 1.244 0 0 0 -.423 1.592l1.2 2"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.5 20.5 1.79-2.237a4 4 0 0 0 .876-2.5v-4.6a1.333 1.333 0 0 0 -1.333-1.333 1.333 1.333 0 0 0 -1.333 1.333v3.333"
    }), /*#__PURE__*/jsx("path", {
      d: "m12.5 20.5v-2.787a3.994 3.994 0 0 1 .673-2.222l1.016-1.524a1.244 1.244 0 0 1 1.757-.4 1.244 1.244 0 0 1 .423 1.592l-1.2 2"
    }), /*#__PURE__*/jsx("path", {
      d: "m13.833 3.833a.667.667 0 0 0 -.667-.667h-1.333a.667.667 0 0 1 -.667-.667v-1.332a.667.667 0 0 0 -.667-.667h-1.333a.667.667 0 0 0 -.667.667v1.333a.667.667 0 0 1 -.667.667h-1.332a.667.667 0 0 0 -.667.667v1.333a.667.667 0 0 0 .667.667h1.333a.667.667 0 0 1 .667.667v5.333a.667.667 0 0 0 .667.667h1.333a.667.667 0 0 0 .667-.667v-5.334a.667.667 0 0 1 .667-.667h1.333a.667.667 0 0 0 .667-.667z"
    })]
  });
};

export { PM2ReligionIcon };
//# sourceMappingURL=religion.js.map
